import { css as cssClassName } from 'emotion';
import React from 'react';
import { Button } from 'shared/Button/NewButton';
import { Modal } from '@spotify-internal/anchor-ds';
import { TFunction, useT } from 'client/i18n/hooks/useT';

export enum ModalActions {
  DELETE_QUESTION = 'DELETE_QUESTION',
  BLOCK_USER = 'BLOCK_USER',
}

export function ConfirmationModal({
  onCancel,
  onConfirm,
  action,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  action: ModalActions;
}) {
  const t = useT();

  if (!action) return null;

  const actionText =
    action === ModalActions.DELETE_QUESTION
      ? t(
          'EpisodeEditorPublish.InteractiveQuestion.ConfirmationModal.DeleteQuestionTitle',
          'delete this question',
          'Delete question confirmation modal title'
        )
      : t(
          'EpisodeEditorPublish.InteractiveQuestion.ConfirmationModal.BlockUserTitle',
          'block this user',
          'Block user confirmation modal title'
        );
  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="confirmation-interactive-question-title"
      onClose={onCancel}
    >
      <Modal.Title id="confirmation-interactive-question-title">
        {t(
          'EpisodeEditorPublish.InteractiveQuestion.ConfirmationModal.Title',
          'Are you sure you want to {actionText}?',
          'Action confirmation modal title',
          { actionText }
        )}
      </Modal.Title>
      <Modal.Body>{getModalCopy(action, t)}</Modal.Body>
      <Modal.Footer>
        <Button type="button" onClick={onCancel}>
          {t('Button.Cancel', 'Cancel', 'Cancel button text')}
        </Button>
        <Button
          className={cssClassName`margin-left: 16px;
`}
          kind="button"
          type="button"
          color="purple"
          onClick={onConfirm}
        >
          {t(
            'EpisodeEditorPublish.InteractiveQuestion.ConfirmationModal.ConfirmActionButtonLabel',
            'Yes, {actionText}',
            'Confirm action button text',
            { actionText }
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function getModalCopy(action: ModalActions, t: TFunction) {
  switch (action) {
    case ModalActions.DELETE_QUESTION:
      return t(
        'EpisodeEditorPublish.InteractiveQuestion.ConfirmationModal.DeleteQuestionMessage',
        "If you delete this question, we won't be able to recover it.",
        'Delete question confirmation modal message'
      );
    case ModalActions.BLOCK_USER:
      return t(
        'EpisodeEditorPublish.InteractiveQuestion.ConfirmationModal.BlockUserMessage',
        'This user will no longer be able to respond to any questions.',
        'Block user confirmation modal message'
      );
    default:
      return null;
  }
}
